const axios = require('axios');
const config = require('../../config/site');

// Post.at Mitarbeiter API
export const toAuth = axios.create({
  baseURL: config.api.authServer.basePath,
  headers: { 'Ocp-Apim-Subscription-Key': config.api.authServer.subscription },
});

// appsolut.FLOW Workflows (Integromat/Make)
export const toFlow = axios.create({
  baseURL: config.api.flowServer.basePath,
});

// Azure Functions
export const toAPI = axios.create({
  baseURL: config.api.apiServer.basePath,
});
